export default __webpack_public_path__ + "static/media/coinTwo.e9dfc596.png";